import React, { useEffect, useState } from 'react'
import Select from "react-select";
import CountryCode from "../../Data/country_code.json";
import './user-login.min.css'
import { capitalizeFirstLetter, messagePopUp, validateEmail } from '../../../utils/Common';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { Link } from 'react-router-dom';
import { subscriptionQuerySubmitData } from '../../services/PricingApi';
import alertPopUp from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { createCallbackRequest } from '../../services/RequestCallbackApi';

const MySwal = withReactContent(alertPopUp);

const SubscriptionSubmitFormModal = (props) => {
    const { handleCloseSubmitPopup, paymentDetails, pageType } = props
    const [errors, setErrors] = useState({});
    const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = useState(false);
    const [formData, setFormData] = useState({ instituteName: "", firstName: "", lastName: "", email: "", mobile: "", message: "", designation: "" });
    const [countryCodeList] = useState([].concat(CountryCode));
    const [countryCode, setCountryCode] = useState({ country: "India", dial: "91", label: "🇮🇳 +91 India", name: "IN", value: "🇮🇳 +91" });

    useEffect(() => {
        window.$("#submitFormModal").modal("show");
        return () => {
            window.$("#submitFormModal").modal("hide");
        }
    }, [])

    const onHandleChange = (event) => {
        setFormData((formData) => ({ ...formData, [event.target.name]: event.target.name === "instituteName" ? event.target.value.trimStart()?.replace(/[^a-zA-Z\s\W_]/g, "") : event.target.name === "email" ? event.target.value?.trimStart()?.replace(/\s/g, "")?.toLowerCase() : (event.target.name === "firstName" || event.target.name === "lastName" || event.target.name === "designation") ? event.target.value?.trimStart()?.replace(/[^a-zA-Z ]/g, "") : (event.target.name === "mobile") ? event.target.value?.trimStart()?.replace(/[^\d\.]*/g, '') : event.target.name === "message" ? event.target.value?.trimStart() : event.target.value?.trimStart()?.replace(/\s/g, "") }));
    };

    const getCountryCodeOptions = () => {
        let sortedCountryCode = countryCodeList && countryCodeList.sort((a, b) => a.Name.localeCompare(b.Name));
        let types = sortedCountryCode.map((option) => {
            return {
                value: option.Unicode + " +" + option.Dial,
                dial: option.Dial,
                country: option.Name,
                label: option.Unicode + " +" + option.Dial + " " + option.Name,
                name: option.Iso2,
            };
        });
        return types;
    };

    const onChangeCountryCode = (data) => {
        setCountryCode(data);
        setFormData((formData) => ({ ...formData, ["mobile"]: "" }));
        setErrors((countryCode) => ({ ...countryCode, ["countryCode"]: "" }));
    }

    const onSubmit = async (event) => {
        event.preventDefault();
        if (validateForm()) {
            setIsSubmitBtnDisabled(true);
            let postData = {
                productType: paymentDetails?.productType,
                type: paymentDetails?.planType,
                ...(paymentDetails?.planType !== "BULK" && (paymentDetails?.productType === "DEVELOP" ? { tenure: paymentDetails?.tenure } : { category: paymentDetails?.category })),
                email: formData?.email,
                instituteName: formData?.instituteName,
                firstName: formData?.firstName,
                lastName: formData?.lastName,
                countryCode: countryCode?.dial,
                mobile: formData?.mobile,
                message: formData?.message,
                ...(pageType === "REQUEST_CALLBACK" && {designation: formData?.designation})
            }
            let response = {}
            if(pageType === "REQUEST_CALLBACK"){
                response = await createCallbackRequest(postData)
            } else{
                response = await subscriptionQuerySubmitData(postData, paymentDetails?.productType);
            }
            if (response?.message === "Success!") {
                handleCloseSubmitPopup(true);
            }
            if (response?.status === "409 CONFLICT") {
                const showSuccessMessageConfirm = async () => {
                    await MySwal.fire(messagePopUp(response?.message));
                };
                showSuccessMessageConfirm();
                setIsSubmitBtnDisabled(false);
            }
        }
    }

    const validateForm = () => {
        let errors = {};
        let formIsValid = true;

        if (!formData?.firstName || (formData?.firstName && formData?.firstName?.length < 2)) {
            errors['firstName'] = !formData?.firstName ? `Please enter first name` : "Please provide minimum two characters";
            formIsValid = false;
        }
        if (!formData?.lastName || (formData?.lastName && formData?.lastName?.length < 2)) {
            errors['lastName'] = !formData?.lastName ? `Please enter last name` : "Please provide minimum two characters";
            formIsValid = false;
        }

        if (!formData?.email) {
            errors['emailId'] = `Please enter your email ID`;
            formIsValid = false;
        }
        if (formData?.email && !validateEmail(formData?.email)) {
            errors['emailId'] = `Please enter a valid email`;
            formIsValid = false;
        }

        if (pageType !== "REQUEST_CALLBACK" && !formData?.instituteName) {
            errors['instituteName'] = `Please enter institute name`;
            formIsValid = false;
        }

        if (!formData?.mobile) {
            errors['mobile'] = `Please enter phone number`;
            formIsValid = false;
        }
        if (formData?.mobile) {
            if (!isValidPhoneNumber(formData?.mobile, countryCode.name)) {
                errors['mobile'] = `Invalid Mobile number : ${formData?.mobile} for country code ${countryCode.dial}`;
                formIsValid = false;
            }
            if (countryCode?.dial === "91") {
                const regExp = /^[6-9\b]+$/;
                if (!regExp.test(formData?.mobile[0]) || formData?.mobile?.length !== 10) {
                    errors['mobile'] = `Please enter a valid phone number`;
                    formIsValid = false;
                }
            } else {
                if (formData?.mobile?.length < 3) {
                    errors['mobile'] = `Please enter a valid phone number`;
                    formIsValid = false;
                }
            }

        }

        if (!formData?.message) {
            errors['message'] = `Please enter message`;
            formIsValid = false;
        }

        setErrors(errors);
        setTimeout(() => {
            setErrors({});
        }, 3000);
        return formIsValid;
    }

    return (
        <div id={"submitFormModal"} className={"modal fade dgModal commonModal"} tabindex="-1" aria-labelledby="reviewPopup" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '600px' }}>
                <div className="modal-content">
                    {/* <button type="button" className="btn-close ckld" aria-label="Close" onClick={handleCloseSubmitPopup}></button> */}
                    <div className="modal-body">
                        <div className="signupbox emailExpVerifMain alreadyVerifiedTemplate m-0">
                            <div className="topHeadSignupBx">
                                <figure className="logoBox">
                                    <Link to={"/"}>
                                        <img
                                            src={"https://cdn.newsepick.com/mobile-logo.png"}
                                            alt="Newsepick"
                                            className="img-fluid"
                                            width={40} />
                                    </Link>
                                </figure>
                                <h4 className="highlight">{pageType === "REQUEST_CALLBACK" ? "Request a Callback" : `Request for ${capitalizeFirstLetter(paymentDetails?.productType.toLowerCase())}`}</h4>
                            </div>

                            <form action="javascript:void(0)" name="signupForm" id="signupForm" onSubmit={onSubmit}>
                                <div className="topFormmsg"><p>Provide the details and we will contact you within 2 working days</p></div>
                                {pageType !== "REQUEST_CALLBACK" && 
                                    <div className={"mb-3" + (errors["instituteName"] ? " error" : "")}>
                                        <label htmlFor="instituteName" className="form-label">Institute Name<mark>*</mark></label>
                                        <input type="text" className="form-control cusfc" name="instituteName" placeholder="Enter Institute Name" value={formData?.instituteName} onChange={onHandleChange} />
                                        {errors["instituteName"] && <span className='login-feedback-error'>{errors['instituteName']}</span>}
                                    </div>
                                }
                                <div className='row'>
                                    <div className={"mb-3 col-sm-6" + (errors["firstName"] ? " error" : "")}>
                                        <label htmlFor="firstName" className="form-label">First Name<mark>*</mark></label>
                                        <input type="text" className="form-control cusfc text-capitalize" name="firstName" placeholder="Enter Your First Name" value={formData?.firstName} onChange={onHandleChange} />
                                        {errors["firstName"] && <span className='login-feedback-error'>{errors['firstName']}</span>}
                                    </div>

                                    <div className={"mb-3 col-sm-6" + (errors["lastName"] ? " error" : "")}>
                                        <label htmlFor="lastName" className="form-label">Last Name<mark>*</mark></label>
                                        <input type="text" className="form-control cusfc text-capitalize" name="lastName" placeholder="Enter Your Last Name" value={formData?.lastName} onChange={onHandleChange} />
                                        {errors["lastName"] && <span className='login-feedback-error'>{errors['lastName']}</span>}
                                    </div>
                                </div>

                                <div className={"mb-3" + (errors["emailId"] ? " error" : "")}>
                                    <label htmlFor="email" className="form-label">Email ID<mark>*</mark></label>
                                    <input type="email" className="form-control cusfc" name="email" placeholder="Enter Your Email ID" value={formData?.email} onChange={onHandleChange} />
                                    {errors["emailId"] && <span className='login-feedback-error'>{errors['emailId']}</span>}
                                </div>

                                <div className={"mb-3" + (errors['mobile'] || errors['countryCode'] ? " error" : "")}>
                                    <label htmlFor="tel" className="form-label">Phone Number <mark>*</mark></label>
                                    <div className='cPhoneField'>
                                        <Select
                                            options={getCountryCodeOptions()}
                                            placeholder={'Code'}
                                            name={'countrycode'}
                                            value={countryCode?.value ? countryCode : ""}
                                            onChange={onChangeCountryCode}
                                            className='countryCode'
                                            classNamePrefix='react-select'
                                            styles={{
                                                option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                                                    const color = '#cfe7c7';
                                                    return {
                                                        ...styles,
                                                        backgroundColor: isDisabled
                                                            ? null
                                                            : isSelected
                                                                ? '#cfe7c7'
                                                                : isFocused
                                                                    ? '#cfe7c7'
                                                                    : null,
                                                        color: isDisabled
                                                            ? '#ccc'
                                                            : isSelected
                                                                ? color > 2
                                                                    ? '#00374d'
                                                                    : '#00374d'
                                                                : data.color,
                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                        ':active': {
                                                            ...styles[':active'],
                                                            backgroundColor: !isDisabled && (isSelected ? '#cfe7c7' : '#cfe7c7'),
                                                        },
                                                    };
                                                },
                                            }}
                                        />
                                        <input type="tel" id="mobile_code" className="form-control" placeholder="Enter your Phone Number" name="mobile" maxLength={countryCode?.dial === "91" ? "10" : "15"} value={formData?.mobile} onChange={onHandleChange} />
                                    </div>
                                    {(errors['countryCode'] || errors['mobile']) && <span className='login-feedback-error'>{errors['countryCode'] ? errors['countryCode'] : errors['mobile']}</span>}
                                </div>

                                {pageType === "REQUEST_CALLBACK" && 
                                    <>
                                        <div className="mb-3">
                                            <label htmlFor="instituteName" className="form-label">Institute Name</label>
                                            <input type="text" className="form-control cusfc" name="instituteName" placeholder="Enter Institute Name" value={formData?.instituteName} onChange={onHandleChange} />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="designation" className="form-label">Designation</label>
                                            <input type="text" className="form-control cusfc" name="designation" placeholder="Enter Designation" value={formData?.designation} onChange={onHandleChange} />
                                        </div>
                                    </>
                                }

                                <div className="mb-3">
                                    <label htmlFor="message" className="form-label">Message<mark>*</mark></label>
                                    <textarea type="email" className="form-control cusfc" name="message" value={formData?.message} placeholder="Enter Your Message" onChange={onHandleChange} />
                                    {errors["message"] && <span className='login-feedback-error'>{errors['message']}</span>}
                                </div>

                                <div className="btnGroupTogether">
                                    <button type="submit" className="btn cusbtn btnPrimary" disabled={isSubmitBtnDisabled}>Submit</button>
                                    <a href="javascript:void(0)" className="btn cusbtn btnDismiss" onClick={() => handleCloseSubmitPopup()}>Cancel</a>
                                </div>

                            </form>
                            <div className="bottomLinks d-flex flex-wrap justify-content-center">
                                <Link to={`mailto:${process.env.REACT_APP_Support_Email}`} className="consupp">Contact Support</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export { SubscriptionSubmitFormModal }